import React from "react";

const DictionaryMobile = () => {
  return <div>Dictionary Mobile</div>;
};
export default DictionaryMobile;
